import Component from '@glimmer/component';

import { service } from '@ember/service';

import WizardSteps from 'rise-ui/components/wizard-steps.gjs';

import gt from 'rise-ui/helpers/gt.js';
import string from 'rise-ui/helpers/string.js';
import sticky from 'rise-ui/modifiers/sticky.js';

export default class StepsComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;
  @service('time-series/outputs') outputs;

  <template>
    <WizardSteps as | wizard |>
      <wizard.Step
        @route="time-series.search"
        @complete={{this.selectedLocations.count}}
        {{sticky activate="wizard-step--small wizard-step--large"}}
      >
        {{string "time-series-search-route"}}
        <wizard.StepDescription>
          Choose locations for which to query data
        </wizard.StepDescription>
        <wizard.StepNote>
          {{#if this.selectedLocations.count}}
            {{this.selectedLocations.count}}
            {{if (gt this.selectedLocations.count 1) "locations" "location"}}
            selected
          {{/if}}
        </wizard.StepNote>
      </wizard.Step>

      <wizard.Step
        @route="time-series.selection"
        @complete={{this.outputs.count}}
      >
        {{string "time-series-selection-route"}}
        <wizard.StepDescription>
          Choose options for data queries
        </wizard.StepDescription>
        <wizard.StepNote>
          {{#if this.outputs.count}}
            {{this.outputs.count}}
            {{if (gt this.outputs.count 1) "queries" "query"}}
            prepared
          {{/if}}
        </wizard.StepNote>
      </wizard.Step>

      <wizard.Step
        @route="time-series.output"
        @last="true"
      >
        {{string "time-series-output-route"}}
        <wizard.StepDescription>
          Download or view query outputs
        </wizard.StepDescription>
      </wizard.Step>
    </WizardSteps>
  </template>
}
